import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Auto-refresh: on 401, refresh the access token once (shared across concurrent calls) and retry.
let refreshPromise = null;
const NO_REFRESH = ["/auth/refresh", "/auth/login", "/auth/logout", "/auth/register"];

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;
    const url = original?.url || "";
    if (error.response?.status === 401 && original && !original._retry && !NO_REFRESH.some((p) => url.includes(p))) {
      original._retry = true;
      try {
        refreshPromise =
          refreshPromise ||
          api.post("/auth/refresh").finally(() => {
            refreshPromise = null;
          });
        await refreshPromise;
        return api(original);
      } catch (e) {
        /* refresh failed -> original 401 wins */
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Ein Fehler ist aufgetreten. Bitte erneut versuchen.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
